export default __webpack_public_path__ + "static/media/google-maps.470bca1f.svg";